import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import reducers from './reducers';
import railsData from '../../../utilities/rails-data';

const middleware = [thunk];

if (railsData('env') === 'development') {
  middleware.push(logger);
}

export default createStore(reducers, applyMiddleware(...middleware));
